module.exports = __webpack_public_path__ + "img/518-42dfb3.png";